module.exports = __webpack_public_path__ + "static/images/projectBOM.0a54bad1.svg";